//Components
import Capsule from 'layout/Capsule';
import OffCanvasViewAppointment from 'components/offcanvas/view-appointment/OffCanvasViewAppointment';
import Calendar from 'components/Calendar';

//Logic
import useAdminCalendar from './useAdminCalendar';

//Utils
import Header from 'layout/header/Header';
import OffcanvasSwitchSlots from './components/OffcanvasSwitchSlots';
import OffCanvasDisableSlots from './components/OffCanvasDisableSlots';
import OffcanvasAddManualAppointment from './components/OffcanvasAddManualAppointment';
import OffCanvasAddOrgAppointment from './components/OffCanvasAddOrgAppointment';
import OffCanvasSettings from './components/OffCanvasSettings';
import { IoCalendarOutline, IoMenuOutline, IoSettingsOutline } from 'react-icons/io5';
import OffcanvasAddBuilding from 'components/offcanvas/add-building/OffcanvasAddBuilding';
import OffCanvasResourceSelected from './components/OffCanvasResourceSelected';
import OffCanvasAddServiceAppointment from './components/OffCanvasAddServiceAppointment';
import { useReducer } from 'react';
import OffcanvasMenu from 'components/offcanvas/OffcanvasMenu';


export default function AdminCalendar() {

  const {
    handleEventClick,
    resources,
    selectedAppointmentId, dispatchViewAppointment,
    showSwitchPhotographers, dispatchShowSwitchPhotographers,
    showDisableSlots, dispatchShowDisableSlots,
    showAddOrgAppointment, dispatchShowAddOrgAppointment,
    showNewBuilding, dispatchShowNewBuilding,
    showOffCanvasSettings, dispatchShowOffCanvasSettings,
    showAddManualAppointment, dispatchShowAddManualAppointment,
    showResourceSelected, dispatchShowResourceSelected,
    showAddServiceAppointment,
    organizationAgents,
    isLoadingOrganizationAgents,
    organizationProducts,
    isLoadingOrganizationProducts,
    resourceInfoSelected, handleSelectResourceInfo,
    handleSelectOrganization,
    handleSelectServiceOrganization,
    handleCloseAddServiceAppointment,
    handleBackAddServiceAppointment,
    organizationSelected,
    handleEventUpdate,
    calendarLogic,
  } = useAdminCalendar();

  const [showMenu, dispatchShowMenu] = useReducer((showMenu, action) => {
      return action === 'CLOSE' ? false : true;
  });

  return (
    <>
      <Capsule className="py-0">
          <Calendar 
            eventDrop={handleEventUpdate}
            eventResize={handleEventUpdate}
            eventClick={handleEventClick}
            editable={true}
            is_admin={true}
            resources={resources || []}
            logic={calendarLogic}
            leftActionButtons={[
              { handleClick: () => dispatchShowMenu('OPEN'), icon: <IoMenuOutline className='me-0'/>, label: 'Menu' },
              { handleClick: () => dispatchShowSwitchPhotographers(true) , label: 'Scambia' },
              { handleClick: () => calendarLogic.changeView('dayGridMonth') , icon: <IoCalendarOutline className='me-0'/>, label: 'Mese'},
              // { handleClick: () => dispatchShowAddOrgAppointment('OPEN') , label: <IoAdd className='me-0'/> }
            ]}
            rightActionButtons={[
              { handleClick: () => dispatchShowOffCanvasSettings(true), label: <IoSettingsOutline className='me-0'/> },
            ]}
            resourceOptionsClick={(info) => {
              handleSelectResourceInfo(info);
              dispatchShowResourceSelected('OPEN')
            }}
            resourceDisableClick={(info) => {
              handleSelectResourceInfo(info);
              dispatchShowDisableSlots('OPEN')
            }}
          />
      </Capsule>
      <OffCanvasViewAppointment 
          appointmentId={selectedAppointmentId}
          handleClose={() => dispatchViewAppointment('CLOSE')}
          photographers={resources}
      />
      <OffcanvasSwitchSlots
        show={showSwitchPhotographers}
        handleClose={() => dispatchShowSwitchPhotographers('CLOSE')}
        photographers={resources}
        switchDate={calendarLogic?.viewDate}
      />
      <OffCanvasDisableSlots
        resourceInfo={resourceInfoSelected}
        show={showDisableSlots}
        handleClose={() => dispatchShowDisableSlots('CLOSE')}
        disableDate={calendarLogic?.viewDate}
      />
      <OffCanvasAddOrgAppointment
        show={showAddOrgAppointment}
        handleClose={() => {
          handleSelectOrganization(null);
          dispatchShowAddOrgAppointment('CLOSE')
        }}
        handleSelectOrganization={handleSelectOrganization}
        handleSelectServiceOrganization={handleSelectServiceOrganization}
        handleNewBuilding={() => dispatchShowNewBuilding('OPEN')}
        organizationSelected={organizationSelected}
        resourceInfo={resourceInfoSelected}
      />
      <OffcanvasAddManualAppointment
        resourceInfo={resourceInfoSelected}
        show={showAddManualAppointment}
        handleClose={() => dispatchShowAddManualAppointment('CLOSE')}
      />
      <OffCanvasResourceSelected
          show={!!showResourceSelected}
          resourceInfo={resourceInfoSelected}
          handleClose={() => dispatchShowResourceSelected('CLOSE')}
          handleSelectManual={() => dispatchShowAddManualAppointment('OPEN')}
          handleSelectClient={dispatchShowAddOrgAppointment}
          handleSelectLock={() => dispatchShowDisableSlots('OPEN')}
      />
      <OffcanvasAddBuilding
          show={!!organizationSelected && showNewBuilding}
          handleClose={() => dispatchShowNewBuilding('CLOSE')}
          organization={organizationSelected}
          isReservation
      />
      <OffCanvasAddServiceAppointment
        show={showAddServiceAppointment}
        handleClose={handleCloseAddServiceAppointment}
        handleBack={handleBackAddServiceAppointment}
        organization={organizationSelected}
        resourceInfo = {resourceInfoSelected}
        agents={organizationAgents}
        isLoadingAgents={isLoadingOrganizationAgents}
        products={organizationProducts}
        isLoadingProducts={isLoadingOrganizationProducts}
        handleSelectServiceOrganization={handleSelectServiceOrganization}
      />
      <OffCanvasSettings
        show={showOffCanvasSettings}
        photographers={resources}
        handleClose={() => dispatchShowOffCanvasSettings('CLOSE')}
      />
      <OffcanvasMenu 
          show={showMenu}
          handleClose={() => dispatchShowMenu('CLOSE')}
      />
  </>);
}
